// extracted by mini-css-extract-plugin
export var buttons = "_ag-0";
export var buttonsActive = "_ag-h";
export var cancelConfirm = "_ag-1";
export var closeButton = "_ag-2";
export var column = "_ag-3";
export var container = "_ag-4";
export var detailHeader = "_ag-6";
export var detailTitle = "_ag-7";
export var detailsContent = "_ag-5";
export var header = "_ag-8";
export var headerWithClose = "_ag-9";
export var icon = "_ag-a";
export var infoIcon = "_ag-c";
export var informationContainer = "_ag-b";
export var sideDrawer = "_ag-d";
export var sideDrawerOpen = "_ag-e";
export var stickyFooter = "_ag-f";
export var typeOption = "_ag-g";